module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.attr_copy != '') ? _c('SgsRenderInputData', {
    attrs: {
      "attr": _vm.attr_copy,
      "fieldValue": _vm.fieldValue,
      "rules": _vm.rules,
      "showHint": _vm.showHint,
      "label": _vm.label,
      "hintValue": _vm.hintValue,
      "moduleType": _vm.moduleType,
      "placeholder": _vm.placeholder,
      "instance": _vm.instance,
      "formIdentifier": _vm.formIdentifier,
      "attrOriginal": _vm.attr,
      "disableField": _vm.disableField
    },
    on: {
      "callBusinessRule": _vm.callBusinessRule
    },
    model: {
      value: (_vm.updateFieldValue),
      callback: function($$v) {
        _vm.updateFieldValue = $$v
      },
      expression: "updateFieldValue"
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4cb64b95!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderInputDataFormWrapper.vue
// module id = 924
// module chunks = 2